/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
var _a;
import { __decorate } from "tslib";
import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { setDefaultAria } from '../../core/utils/a11y-utils';
import { CUSTOM_ELEMENT_NAME_PROPERTY } from '@tylertech/forge-core';
import { BaseLitElement } from '../../core/base/base-lit-element';
const styles = ':host{display:block}.forge-key{--_key-gap:var(--forge-key-gap, var(--forge-spacing-medium, 16px));--_key-direction:var(--forge-key-direction, row)}.forge-key{box-sizing:border-box;display:flex;flex-direction:var(--_key-direction);gap:var(--_key-gap);flex-wrap:wrap}';
export const KEY_TAG_NAME = 'forge-key';
/**
 * @tag forge-key
 *
 * @summary Keys present key items to label a chart or data visualization.
 *
 * @slot - The default slot for key items.
 *
 * @cssproperty --forge-key-gap - The spacing between key items.
 * @cssproperty --forge-key-direction - The direction that items are laid out in the key.
 *
 * @csspart root - The root element.
 */
let KeyComponent = class KeyComponent extends BaseLitElement {
    constructor() {
        super();
        this._internals = this.attachInternals();
    }
    connectedCallback() {
        super.connectedCallback();
        setDefaultAria(this, this._internals, {
            role: 'list'
        });
    }
    /* @internal */
    render() {
        return html `<div part="root" class="forge-key"><slot></slot></div>`;
    }
};
_a = CUSTOM_ELEMENT_NAME_PROPERTY;
KeyComponent.styles = unsafeCSS(styles);
/** @deprecated Used for compatibility with legacy Forge @customElement decorator. */
KeyComponent[_a] = KEY_TAG_NAME;
KeyComponent = __decorate([
    customElement(KEY_TAG_NAME)
], KeyComponent);
export { KeyComponent };
